var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconUndo = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_527_10079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2435 9.98519C14.2435 13.3018 11.5451 16 8.22871 16H6.09957C5.74674 16 5.46082 15.7141 5.46082 15.3613V15.1484C5.46082 14.7955 5.74671 14.5096 6.09957 14.5096H8.22871C10.7234 14.5096 12.7531 12.4799 12.7531 9.98519C12.7531 7.49052 10.7234 5.46075 8.22871 5.46075H4.30057L7.00588 8.16606C7.29644 8.45652 7.29644 8.92938 7.00588 9.21984C6.72393 9.50157 6.23325 9.50115 5.95193 9.21984L1.97472 5.24252C1.83397 5.10177 1.75641 4.91463 1.75641 4.71552C1.75641 4.51656 1.83397 4.32931 1.97472 4.18864L5.95214 0.211143C6.23346 -0.070381 6.72457 -0.070381 7.00591 0.211143C7.29648 0.501531 7.29648 0.974455 7.00591 1.26481L4.30061 3.97033H8.22871C11.5451 3.97033 14.2435 6.66867 14.2435 9.98519Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_527_10079"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconUndo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-undo.50eb9ccc.svg";
export { ForwardRef as ReactComponent };